export default __webpack_public_path__ + "static/media/chickpea_salmon.8172e1a9.jpg";